export const IntegrationCard = {
  flow: 'x',
  align: 'flex-start flex-start',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  cursor: 'pointer',
  transition: 'border 150ms ease',
  ':hover': { border: '1px solid inkSubtle' },
  on: {
    click: (e, el, s) => {
      s.root.update({
        integrationModal: {
          open: true,
          name: s.name,
          category: s.category,
          status: s.status,
          logoUrl: s.logoUrl,
          protocol: s.protocol
        }
      })
    }
  },

  LogoImg: {
    tag: 'img',
    src: (el, s) => {
      if (s.logoUrl) return s.logoUrl
      const name = s.name || 'I'
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=f0f0f0&color=333&size=96&bold=true&format=svg`
    },
    attr: { onerror: "this.src='https://ui-avatars.com/api/?name='+encodeURIComponent(this.closest('[key]')?.querySelector('[key=Name]')?.textContent||'?')+'&background=f0f0f0&color=333&size=96&bold=true&format=svg'" },
    width: 'A1',
    height: 'A1',
    round: 'Y',
    marginTop: 'X',
    flexShrink: '0',
    objectFit: 'contain',
    background: 'inkSurface'
  },
  InfoSection: {
    flow: 'y',
    gap: 'W',
    flex: '1',
    Name: { text: (el, s) => s.name || 'Integration', fontSize: 'A', fontWeight: '600', color: 'inkText', lineHeight: '1', margin: '- - X2 -' },
    CategoryTag: {
      tag: 'span',
      text: (el, s) => s.category || 'EHR',
      fontSize: 'Y',
      padding: 'X Y',
      round: 'B',
      background: 'inkSurface',
      color: 'inkMuted',
      alignSelf: 'flex-start'
    }
  },
  RightSection: {
    flow: 'y',
    align: 'flex-end center',
    gap: 'Y',
    ConnectionStatus: {
      flow: 'x',
      align: 'center center',
      gap: 'X',
      Dot: {
        width: '8px',
        height: '8px',
        round: 'D',
        background: (el, s) => {
          const st = s.status || 'available'
          if (st === 'connected') return 'green'
          if (st === 'disconnected') return 'red'
          if (st === 'syncing') return 'blue'
          return 'inkMuted'
        }
      },
      Label: {
        text: (el, s) => {
          const st = s.status || 'available'
          if (st === 'connected') return 'Connected'
          if (st === 'disconnected') return 'Disconnected'
          if (st === 'syncing') return 'Syncing'
          return 'Not Installed'
        },
        fontSize: 'Y',
        color: (el, s) => {
          const st = s.status || 'available'
          if (st === 'connected') return 'green'
          if (st === 'disconnected') return 'red'
          return 'inkMuted'
        }
      }
    },
    ConfigButton: {
      extends: 'Button',
      text: (el, s) => s.status === 'connected' ? 'Configure' : 'Install',
      fontSize: 'Y',
      padding: 'X Z',
      round: 'Y',
      background: (el, s) => s.status === 'connected' ? 'inkSurface' : 'inkText',
      color: (el, s) => s.status === 'connected' ? 'inkText' : 'inkMid',
      fontWeight: '500',
      cursor: 'pointer',
      border: '1px solid inkBorder'
    }
  }
}
